import { whatIfInnerSelector } from '../../../WhatIfsSelector';

const HOAvalue = (state, props) => (
  whatIfInnerSelector(state, props).MonthlyHoa
);

export default HOAvalue;
